export default "__VITE_ASSET__BgDyYX1z__"